import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../../redux/user/user-selector";
import { errorNotification } from "../../../../redux/notifications";
import { useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import TemplateHeader from "../../../../components/TemplateHeader/TemplateHeader";
import CustomDropdown from "../../../../components/dropdown-main/DropdownMain";
import DocumentItem from "./DocumentItem/DocumentItem";
import FileUploader from "./FileUploader/FileUploader";
import WelcomeScreen from "../../../../components/WelcomeScreen/WelcomeScreen";
import { PulseLoader } from 'react-spinners';
import ListGroup from "react-bootstrap/ListGroup";
import { OLD_UI_URL} from "../../../../services/api/api-client";
import "./task-create-document-modal.scss";

import { GetUserToken } from '../../../../services/api/user-api';
import { GetCurrentUserNewAPI } from "../../../../services/api/authentication-api";
import { GetUserProjects, GetProjectDocument, UploadProjectDocument } from "../../../../services/api/project-api";

import _ from "lodash";

const getExtension = (fileName) => {
    return fileName.toLowerCase().substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName;
}

function delay(delayInms) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(2);
      }, delayInms);
    });
}

const  SearchBar = (props) => {
    return (
        <Form.Group>
            <Form.Label className="task-sub-label">Select an existing file</Form.Label>
            <Form.Control
                type="text"
                placeholder="Search for files"
                onChange={(e) => props.onSearch(e.target.value)}
                value={props.value}
                required
                autoComplete="off"
            />
            <div className="search-icon"></div>
        </Form.Group>
    );
}

const TaskCreateDocumentModal = (props) => {
    const [projects, setProjects] = useState([]);
    const [projectDocuments, setProjectDocuments] = useState([]);
    const [currProjectDocument, setCurrProjectDocument] = useState(null);
    const [currProject, setCurrProject] = useState(null);
    const [documentToSearch, setDocumentToSearch] = useState("");
    const [documentSelected, setDocumentSelected] = useState("");
    const [welcomeScreen, setWelcomeScreen] = useState(false);
    const [isInternalOrProductionEnv, setIsInternalOrProductionEnv] = useState(false);
    const [oldUIToken, setOldUIToken] = useState("");
    const [redirectingToOldUI, setRedirectingToOldUI] = useState(false);
    const [activatePulseLoader, setActivatePulseLoader] = useState(false);
    const currentUser = useSelector(selectUser);
    const canCreateProject = currentUser?.privileges?.Projects.Add;

    const [projectId, setProjectId] = useState(props?.projectId ?? null);

    const dispatch = useDispatch();

    let history = useHistory();

    const checkEnvironment = () => {
        let currentURL = window.location.href;
        let ifExpression = currentURL.includes("qa.triyo") ||
        //currentURL.includes("qa2.triyo") ||
        currentURL.includes("sandbox.triyo") ||
        currentURL.includes("intranet.triyo") ||
        currentURL.includes("demo.triyo") ||
        currentURL.includes("domcap.triyo") ||
        currentURL.includes("rbctest.triyo/") ||
        currentURL.includes("triyoqa.oak.fg.rbc") ||
        currentURL.includes("triyo.oak.fg.rbc") ||
        //currentURL.includes("localhost:3000") || //Testing here the Footer. According to the TAD-1514, internal and production environments have disabled footer
        currentURL.includes("localhost:44339");

        setIsInternalOrProductionEnv(!!ifExpression);
    }

    const removeIfOverdue = (userProjects) => {
        var today = new Date();

        return userProjects.filter(project =>{
            var projectEnd = new Date(project.end);
            return (projectEnd.getTime() >= today.getTime());
        });
    }
    

    // Data fetching for user and then projects
    const fetchProjectsData = async() => {
        setActivatePulseLoader(true);
        await GetCurrentUserNewAPI()
            .then(async(currentUser) => {
                if (currentUser) {
                    await GetUserProjects(currentUser.UserId)
                        .then((getuserprojectsT) => {
                            // lowercase keys: Id and Name => id and name (for sorting reasons with dropdown component)
                            let userProjectsLowerCase = getuserprojectsT.map((project) => _.mapKeys(project, function(v, k) { return k.toLowerCase(); }));
                            let userProjects = removeIfOverdue(userProjectsLowerCase);
                            setProjects(userProjects);
                            if (projectId) {
                                setCurrProject(userProjects.find((project) => (project.id === Number(projectId))));
                            }
                        })
                    await GetUserToken().then(
                        (result) => {                                
                            setActivatePulseLoader(false);
                            setOldUIToken(result.data.Token);                                
                        },
                        (error) => { setActivatePulseLoader(false); }
                    )
                }
            })
    };

    useEffect(() => {
        checkEnvironment();
        fetchProjectsData();
    }, []);

    // Find selected project and store documents
    const findSelectedProject = (projectid) => {
        if (currProject) {
            let selectedProject = projects.find((project) => (project.id === projectid));
            if (selectedProject) {
                setProjectDocuments(selectedProject);
            } else {
                setProjectDocuments([]);
            }
        }
    };

    useEffect(() => {
        if (currProject) findSelectedProject(currProject.id);
    }, [currProject]);


    // Data fetching for selected document -> here we are going to download file //Tested working pptx and docx
    const fetchDownloadDocument = async (document) => {
        await GetProjectDocument(document.FileNameId, document.Name)
        .then(async (result) => { setActivatePulseLoader(false); }, (error) =>  setActivatePulseLoader(false))
    };

    //#1 Data fetching for selected document -> here we are going to upload a new file //Tested working pptx and docx
    const fetchUploadDocument = async (file, projectId, fileType, documentId, fileName) => {
        await UploadProjectDocument(file, projectId, fileType, documentId, fileName)
            .then(async (result) => {
                if (result) {
                    setCurrProjectDocument(result);
                    let delayWelcome = await delay(3000);
                    setActivatePulseLoader(true)
                    //#2 Download the  file from the system a ask user to open word/pptx
                    await GetProjectDocument(result.FileNameId, result.Name)
                        .then((res) => {
                            setWelcomeScreen(true);
                        },
                        (error) => setActivatePulseLoader(false))

                    console.log("File " + fileName + " uploaded successfully!");
                    setActivatePulseLoader(false);
                }
        })
    };

    const noDocuments = !projectDocuments.documents || projectDocuments.documents.length===0;

    const filterNames = ({ Name }) => {
        return Name.toLowerCase().indexOf(documentToSearch.toLowerCase()) !== -1;
    };

    const onSelect = (document) => {
        if (getExtension(document.FileName) == "xlsx" || document.DocumentTypeId === 2) {
            setRedirectingToOldUI(true);
            window.location.href = OLD_UI_URL + "home/CreateAssignmentWeb?token=" + oldUIToken + "&ProjectID=" + currProject.id;
        } else {
            setActivatePulseLoader(true);
            setDocumentSelected(document.Name);
            setCurrProjectDocument(document);
            setWelcomeScreen(true);
            fetchDownloadDocument(document);
        }
    };

    const onClickDownloadDocument = (document) => {
        setActivatePulseLoader(true);
        fetchDownloadDocument(document);
    }


    // CREATE PROJECT routing function
    const openCreateNewProject = () => {
        if (canCreateProject) {
            let location = {
                pathname: "/projects/create",
                state: {
                originIsCreateDCTaskModal: true,
                },
            };
            props.onHide();
            history.push(location);
        } else {
            dispatch(errorNotification({
                header: "User cannot create projects",
                message: "Contact your administrator to request permission to create projects",
            }));
        }
    };

    // Upload file handler for pptx, docx and xxls -> not accepting other files
    const handleSelectedFile =  async(file) => {
        let fileTypeT;

        // Get fileType
        if (file.type.includes("officedocument.wordprocessingml.document") || getExtension(file.name) == "docx" ) {
            fileTypeT = 1;
            fetchUploadDocument(file, currProject.id, fileTypeT, file.name);
            setDocumentSelected(file.name);
        } else if (file.type.includes("officedocument.spreadsheetml.sheet") || getExtension(file.name) == "xlsx") {
            fileTypeT = 2;
            setRedirectingToOldUI(true);
            window.location.href = OLD_UI_URL + "home/CreateAssignmentWeb?token=" + oldUIToken + "&ProjectID=" + currProject.id;
        } else if (file.type.includes("officedocument.presentationml.presentation") || getExtension(file.name) == "pptx" ) {
            fileTypeT = 3;
            fetchUploadDocument(file, currProject.id, fileTypeT, file.name);
            setDocumentSelected(file.name);
        }else if(getExtension(file.name) === "doc"||getExtension(file.name) === "ppt"||getExtension(file.name) === "xls"){
            dispatch(errorNotification({
                header: "Unsupported File Extension",
                message: "A task file with an unsupported extension was uploaded. The File format must be .docx, pptx, or .xlsx",
            }));

        } else {
            dispatch(errorNotification({
                header: "Unsupported File Type",
                message: "An unsupported task file type was uploaded. Please select a Microsoft Word, PowerPoint, or Excel document, and try again",
            }));
        }
    }

    return (
        <Modal show = { props.show } onHide = { props.onHide } contentClassName = { `modal-styles ${welcomeScreen? "welcome-layout" : ""}` } className = "document-collaboration-modal">
            {
                activatePulseLoader &&
                <div className={`pulse-loader ${noDocuments?"":"modal-expanded"}`} >
                    <PulseLoader / >
                </div>
            }
            <Modal.Header>
                <TemplateHeader
                    heading="Create Task"
                    subHeading="Document Collaboration"
                    onClose={()=>props.onHide()}
                />
            </Modal.Header>

            <Modal.Body className="action-popup">
                <Container>
                    {
                        !welcomeScreen &&
                        <React.Fragment>
                            <Row className="project-section">
                                <Col xs="2" style={{ margin: "0xp", padding: "0px", textAlign: "left" }}>
                                    <h5 className="project-label">Project</h5>
                                </Col>
                                <Col xs="8">
                                    <Row>
                                        <h5 className="project-sub-label">Select a project</h5>
                                    </Row>
                                    <Row className="project-dropdown-container" >
                                        <div className="project-dropdown">
                                            <CustomDropdown
                                                values ={projects}
                                                dropdownButtonText={projects?.length>0? "Select a project" : "No project found"}
                                                onSelect={(selectedValue) => setCurrProject(selectedValue)}
                                                currentSelected={currProject}
                                                disabled={!projects?.length}
                                            />
                                            <p></p>
                                        </div>
                                        <div className="nav-link">
                                            <div onClick={(e) => openCreateNewProject()} className="create-button"></div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs="2">
                                </Col>
                            </Row>
                            <Row className="task-section">
                                <Col xs="2" style={{ margin: "0xp", padding: "0px", textAlign: "left" }}>
                                    <h5 className="task-label">Task File</h5>
                                </Col>
                                <Col xs="8">
                                    { !noDocuments &&
                                    <React.Fragment>
                                        <Row style={{ margin: "0xp", padding: "0px" }}>
                                            <SearchBar onSearch={setDocumentToSearch} value={documentToSearch} />
                                            <ListGroup>
                                                <div className="list-item-container">
                                                    <div className="list-item-sub-container">
                                                        {
                                                            projectDocuments.documents && projectDocuments.documents.filter(filterNames).map((document) => {
                                                                return <DocumentItem key={document.Id} documentName={document.Name} onSelect={(e) => onSelect(document)}/>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </ListGroup>
                                        </Row>
                                        <p className="or-label">or</p>
                                    </React.Fragment>
                                    }
                                    <React.Fragment>
                                        <FileUploader disabled={!currProject} isRedirecting={redirectingToOldUI}
                                            onFileSelectSuccess={(file) => { if (currProject) handleSelectedFile(file)}}
                                            onFileSelectError={({ error }) => console.log(error)} // Recommended a file size limit to avoid users uploading files 150MB for example
                                        />
                                    </React.Fragment>
                                </Col>
                                <Col xs="2">
                                </Col>
                            </Row>
                        </React.Fragment>
                    }
                    {
                        welcomeScreen &&
                        <WelcomeScreen documentName={documentSelected} onClick={ (e) => onClickDownloadDocument(currProjectDocument) }/>
                    }
                </Container>
            </Modal.Body>
            {
            !isInternalOrProductionEnv &&
            <Modal.Footer style={{ borderTop: "1px solid lightgray", height: "60px"}}>
                <Container>
                    <Row>
                        <span className="footer-text">Don't have TRIYO's Add-ins yet?&nbsp;
                            <a target="_blank" href="https://appsource.microsoft.com/en-us/product/office/WA200003574?src=office">
                                Get them from the Microsoft Store
                            </a>
                        </span>
                    </Row>
                </Container>
            </Modal.Footer>
            }
        </Modal>
    );
}

export default TaskCreateDocumentModal;